import { render, staticRenderFns } from "./timeEtymta.vue?vue&type=template&id=64521b01&scoped=true"
import script from "./timeEtymta.vue?vue&type=script&lang=js"
export * from "./timeEtymta.vue?vue&type=script&lang=js"
import style0 from "./timeEtymta.vue?vue&type=style&index=0&id=64521b01&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64521b01",
  null
  
)

export default component.exports